import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";
import MeusHorariosPage from "@/Pages/Instrutores/MeusHorariosPage.vue";
import InstrutoresHorariosAdminPage from "@/Pages/Instrutores/InstrutoresHorariosAdminPage.vue";

async function redirecionarSemProfessor(to, from, next) {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
    currentUser = store.getters["Auth/user"];
  }

  if (!currentUser?.professor?.id) {
    return next({ name: "home" });
  }

  return next();
}

export default [
  {
    path: "/instrutores/meus-horarios",
    name: "instrutores.meusHorarios",
    title: "Meus Horários",
    component: MeusHorariosPage,
    beforeEnter: redirecionarSemProfessor,
  },
  {
    path: "/instrutores/horarios",
    name: "instrutores.horarios",
    title: "Horários dos Professores",
    component: InstrutoresHorariosAdminPage,
  },
];
